export default "__VITE_ASSET__r6oAM7Hk__"